module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/139.0a3798d5.png";